import { Component, DestroyRef, OnInit } from '@angular/core';
import moment from 'moment';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.state';
import { Observable } from 'rxjs';
import { SharedEffects } from '@effects/shared.effects';
import { UserSelectors } from '@states/user/user.selector-types';
import { UserActions } from '@states/user/user.action-types';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-profile-settings',
  templateUrl: './profile-settings.component.html',
  styleUrls: ['./profile-settings.component.scss'],
  standalone: false,
})
/**
 * @deprecated
 */
export class ProfileSettingsComponent implements OnInit {
  public timeZones = moment.tz.names();
  public currentTimezone = moment.tz.guess();

  public selectUserTimezone$: Observable<string> = this.store$.select(UserSelectors.selectUserTimezone);

  constructor(
    private store$: Store<AppState>, 
    private sharedEffects$: SharedEffects,
    private destroyRef: DestroyRef,
  ) {}

  public ngOnInit(): void {
    this.selectUserTimezone$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.currentTimezone = res;
    });

    this.sharedEffects$.pressSave$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.save();
    });
  }

  public setTimezone(timezone: string): void {
    this.store$.dispatch(UserActions.setTimezone({ timezone }));
  }

  public save(): void {
    this.store$.dispatch(UserActions.updateUser());
  }
}
